import React from 'react'

function MentorAssignAlert() {
  return (
    <div>Either Mentor is not assigned or No mentor slots available.</div>
  )
}

export default MentorAssignAlert